import React, { useState, useEffect } from 'react';
import './assets/styles/Modal.css';

const EditMessageModal = ({ show, onClose, petId, field, currentValue, handleSave }) => {
    const [editedValue, setEditedValue] = useState(currentValue || '');

    // const [editedValue, setEditedValue] = useState('');

    // useEffect(() => {
    //     if (show) {
    //         console.log("Modal opened, setting value to:", currentValue); // Debugging

    //         setEditedValue(currentValue || ''); // Ensure the value is reset when modal opens
    //     }
    // }, [show, currentValue]); // Update when modal opens or value changes

    const handleInputChange = (e) => {
        setEditedValue(e.target.value);
    };

    const handleSaveClick = () => {
        handleSave(petId, field, editedValue); // Save function passed as a prop
        onClose(); // Close modal after save
    };

    if (!show) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                {/* <h2>Edit {field}</h2> */}
                <h2>Editar campo</h2>
                <input
                    type="text"
                    value={editedValue}
                    onChange={handleInputChange}
                    className="modal-input"
                    placeholder={`Editar campo`}
                />
                <div className="modal-actions">
                    <button onClick={handleSaveClick} className="modal-button save-button">Actualizar</button>
                    <button onClick={onClose} className="modal-button cancel-button">Cancelar</button>
                </div>
            </div>
        </div>
    );
};

export default EditMessageModal;
